import React from 'react';
import { useStyletron } from 'baseui';
import { Textarea } from 'baseui/textarea';
import { FormControl } from 'baseui/form-control';
import ReactDiffViewer from 'react-diff-viewer';
import { formatJson } from '../../utils/formatters';

interface ValueEditorProps {
	currentValue: string;
	proposedValue: string;
	onProposedChange: (value: string) => void;
	onCurrentChange?: (value: string) => void;
}

const ValueEditor: React.FC<ValueEditorProps> = ({ currentValue, proposedValue, onProposedChange, onCurrentChange }) => {
	const [css] = useStyletron();

	const formattedProposed = formatJson(proposedValue);

	return (
		<div>
			{/* Side-by-side editors */}
			<div className={css({ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' })}>
				<FormControl label='Current Value' caption='Auto-filled when available; paste the live value for accurate analysis'>
					<Textarea
						value={currentValue}
						onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onCurrentChange && onCurrentChange(e.target.value)}
						placeholder='Paste current value (JSON or plain text)'
						overrides={{
							Input: {
								style: {
									fontFamily: 'monospace',
									fontSize: '13px',
									minHeight: '150px'
								}
							}
						}}
					/>
				</FormControl>
				<FormControl label='Proposed Value'>
					<Textarea
						value={proposedValue}
						onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onProposedChange(e.target.value)}
						placeholder='Enter proposed value (JSON or plain text)'
						overrides={{
							Input: {
								style: {
									fontFamily: 'monospace',
									fontSize: '13px',
									minHeight: '150px'
								}
							}
						}}
					/>
				</FormControl>
			</div>

			{/* Diff viewer */}
			{currentValue && proposedValue && (
				<div
					className={css({
						border: '1px solid #E2E2E2',
						borderRadius: '8px',
						overflow: 'hidden'
					})}>
					<div
						className={css({
							backgroundColor: '#F6F6F6',
							padding: '8px 12px',
							fontSize: '13px',
							fontWeight: 600,
							borderBottom: '1px solid #E2E2E2'
						})}>
						Changes
					</div>
					<ReactDiffViewer oldValue={currentValue} newValue={formattedProposed} splitView useDarkTheme={false} />
				</div>
			)}
		</div>
	);
};

export default ValueEditor;
